/**
 * The languages both AI bots (internal assistant + public crop advisor) can reply in. Shared so the
 * two pickers stay identical. `label` is the native script (shown in the dropdown); `value` is the
 * code sent to the backend as `lang`. The backend has hand-written templates for en/hi/mr and uses
 * the LLM to translate the rest (falling back to English when the LLM is offline).
 */
export interface AiLanguage { value: string; label: string }

export const AI_LANGUAGES: AiLanguage[] = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'हिन्दी' },
  { value: 'mr', label: 'मराठी' },
  { value: 'gu', label: 'ગુજરાતી' },
  { value: 'bn', label: 'বাংলা' },
  { value: 'or', label: 'ଓଡ଼ିଆ' },
  { value: 'pa', label: 'ਪੰਜਾਬੀ' },
  { value: 'te', label: 'తెలుగు' },
  { value: 'ta', label: 'தமிழ்' },
  { value: 'kn', label: 'ಕನ್ನಡ' },
];
